.root {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--form-item-base-height);
  height: 100%;

  button {
    padding: 0;
  }

  svg {
    width: 20px;
    height: 20px;
  }
}

.end {
  right: 0;
}

.start {
  left: 0;
}

.clickthrough {
  pointer-events: none;
}
